import React from "react";
import { Link } from "react-router-dom";
import "../../css/Navbar.css";
import Logo from "../../assets/images/ava_rose_logo.png";
import { ReactComponent as FacebookIcon } from "../../assets/icons/facebook.svg";
import { ReactComponent as LinkedInIcon } from "../../assets/icons/LinkedIn.svg";
import { ReactComponent as InstaIcon } from "../../assets/icons/instag.svg";
import { ReactComponent as HomeIcon } from "../../assets/icons/house_icon 2.svg";
import { ReactComponent as EmailIcon } from "../../assets/icons/email.svg";
import { ReactComponent as PhoneIcon } from "../../assets/icons/phone.svg";

function Navbar() {
  return (
    <header>
      <div className="navbar-topbar">
        <div className="navbar-topbar-content">
          <div className="topbar-contact info">
            <a
              href="mailto:michael@avarosemortgages.co.uk"
              className="topbar-link"
            >
              <div
                className="
             topbar-contact nav-item"
              >
                <EmailIcon /> michael@avarosemortgages.co.uk
              </div>
            </a>
            <a href="tel:07759727170" className="topbar-link">
              <div className="topbar-contact nav-item">
                <PhoneIcon /> 07759 727170
              </div>
            </a>
          </div>
          <Link to="/" className="topbar-home" aria-label="Home">
            <HomeIcon />
          </Link>
        </div>
      </div>

      <nav className="navbar">
        <div className="navbar-container">
          <div className="logo">
            <Link to="/">
              <img
                src={Logo}
                alt="Ava Rose Mortgages Ltd Logo"
                className="logo-icon"
              />
            </Link>
          </div>

          <ul className="nav-menu">
            <li>
              <Link to="/about" className="nav-item">
                About Us
              </Link>
            </li>
            <li>
              <Link to="/mortgages" className="nav-item">
                Mortgages
              </Link>
            </li>
            <li>
              <Link to="/protection" className="nav-item">
                Protection
              </Link>
            </li>
            <li>
              <Link to="/other-services" className="nav-item">
                Other Services
              </Link>
            </li>
            <li>
              <Link to="/contact" className="nav-item">
                Contact Us
              </Link>
            </li>
            {/* <li>
              <Link to="/blogs" className="nav-item">
                Blogs
              </Link>
            </li> */}
          </ul>

          <div className="navbar-social" aria-label="Social links">
            <a
              href="https://www.instagram.com/avarosemortgages/"
              target="_blank"
              rel="noopener noreferrer"
              className="navbar-social-icon"
              aria-label="Instagram"
            >
              <InstaIcon />
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=61580737965094"
              // href="https://www.facebook.com/michael.hunt.12935"
              target="_blank"
              rel="noopener noreferrer"
              className="navbar-social-icon"
              aria-label="Facebook"
            >
              <FacebookIcon />
            </a>
            <a
              href="https://www.linkedin.com/in/tax-advisor/"
              target="_blank"
              rel="noopener noreferrer"
              className="navbar-social-icon"
              aria-label="LinkedIn"
            >
              <LinkedInIcon />
            </a>
          </div>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;
